import './styles.scss';
import { useEffect, useState } from 'react';
import { Pagination } from 'views/components/atoms/pagination';
import { BodyShowList } from 'views/components/molecules/listBody';
import { List } from 'views/components/organisms/list';
import { getAccountTransactionHistoryHeaderShowList } from 'views/constants/const/AccountTransactionHistory';
import { calcTotalPage } from 'views/utils/calc/pagination';
import { createBodyShowLists } from './function/createBodyShowList';
import { GetAccountTransactionHistoryQueryVariables } from 'views/utils/graphql/graphql';
import { useGetAccountTransactionHisotry } from './function/useGetAccounTransactionHistory';
import { PageLocationSP } from 'views/components/atoms/pageLocation';

export const AccountTransactionHistory = () => {
  const PAGE_COUNT = 15;
  const [currentPage, setCurrentPage] = useState<number>(1);

  const getAccountTransactionHistoryVariables = () => {
    const param: GetAccountTransactionHistoryQueryVariables = {
      count: PAGE_COUNT,
      page: currentPage,
    };
    return param;
  };

  const { accountTransactionHistory, setAccountTransactionVariable } = useGetAccountTransactionHisotry(
    getAccountTransactionHistoryVariables(),
  );

  const [bodyShowLists, setBodyShowLists] = useState<BodyShowList[]>([]);

  useEffect(() => {
    if (!accountTransactionHistory.data) return;
    setBodyShowLists(createBodyShowLists(accountTransactionHistory.data));
  }, [accountTransactionHistory]);

  return (
    <section className="outletWrapper accountTransactionHistoryWrapper">
      <div className="centerContent">
        <PageLocationSP />
        <List
          headerShowList={getAccountTransactionHistoryHeaderShowList()}
          bodyShowLists={bodyShowLists}
          loading={accountTransactionHistory.fetching}
        />
        {/* ページネーション */}
        <Pagination
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          fetchApi={() => setAccountTransactionVariable(getAccountTransactionHistoryVariables())}
          pageCount={calcTotalPage(
            accountTransactionHistory.data?.GetAccountTransactionHistory?.TotalCount
              ? accountTransactionHistory.data?.GetAccountTransactionHistory?.TotalCount
              : 1,
            PAGE_COUNT,
          )}
        />
      </div>
    </section>
  );
};
